module.exports = __webpack_public_path__ + "img/logo-poli.b9ca7a27.svg";